import { type StateType } from '../../states';
import { type Cashout } from '../../states/cashout';
import { type Selector } from '../../types/selectors';
import { getBetslipIdFromProps } from '../_propsGetters_';

const emptyObj = {};

export const selectCashoutState: Selector<Cashout> = (state: StateType) => state.cashout ?? emptyObj;

//#region state.cashout[betslipId]
type CashoutSelectorProps = {
  betslipId?: number;
  id?: number;
};

export const selectIsBetslipCashout: Selector<boolean | null | undefined> = (
  state: StateType,
  props: CashoutSelectorProps = {},
) => {
  const cashoutState = selectCashoutState(state);
  const id = getBetslipIdFromProps(state, props);

  if (id) {
    return cashoutState[id];
  }
};
//#endregion
